import {ILogService} from "angular";
import {ReferenceData} from "./reference-data.service";

/* @ngInject */
export const DescriptionFilter = (referenceData: ReferenceData, $log: ILogService): IDescriptionFilter => {

    const data: IDescriptionFilter = (input: string, type: string) => {
        const result = referenceData.getDescription(type, input);

        return result;
    };
    $log.debug("referenceData %o", referenceData);
    return data;

};

export type IDescriptionFilter = (input: string, type: string) => string;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/reference-data/description.filter.ts